// @ts-nocheck

import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import PropTypes from 'prop-types'
import React from 'react'
import { Check } from 'react-feather'

function FormikCheckBox({ setFieldValue, name, label, checked }) {
  return (
    <FormControlLabel
      value="end"
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => {
            setFieldValue(name, e.target.checked)
          }}
          checkedIcon={<Check aria-label={label} />}
          color="primary"
          aria-label={label}
        />
      }
      label={label}
      labelPlacement="end"
    />
  )
}

FormikCheckBox.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  setFieldValue: PropTypes.func,
}

FormikCheckBox.defaultProps = {
  name: '',
  className: '',
  label: '',
  checked: false,
  disabled: false,
  setFieldValue: () => {},
}

export default FormikCheckBox
